import React from 'react';
import { Grid, SpaceWrapper, StickyNavigation } from 'ui-toolkit/index';
import { LeftSideAdministrationMenu } from '../../components/administration/subComponents/LeftSideAdministrationMenu';
import { Route } from 'react-router-dom';
import { AdminUsersContainer } from '../../components/administration/adminUsers/AdminUsersContainer';
import { Redirect, Switch, useRouteMatch } from 'react-router';
import { UserProfileContainer } from '../../components/userProfile/UserProfileContainer';
import { PricingAdministrationContainer } from '../../pages/administration/pricing/PricingAdministrationContainer';
import { UnderwriterProfileDetailContainer } from '../../pages/administration/pricing/UnderwriterProfileDetailContainer';
import { FeaturesContainer } from '../../components/administration/features/FeaturesContainer';
import { FeatureRolesContainer } from '../../components/administration/features/FeatureRolesContainer';
import { FeatureIdentitiesContainer } from '../../components/administration/features/FeatureIdentitiesContainer';
import { RolesContainer } from '../../pages/administration/roles/RolesContainer';
import { TagsContainer } from '../../pages/administration/tags/TagsContainer';
import { CreateTagContainer } from '../../pages/administration/tags/CreateTagContainer';
import { EditTagContainer } from '../../pages/administration/tags/EditTagContainer';
import { useDocumentTitleEffect } from '../../utilities/hooks/useDocumentTitleEffect';

export const AdministrationRouter = () => {
  useDocumentTitleEffect('Administration');
  let { path, url } = useRouteMatch();
  return (
    <>
      <StickyNavigation activeMain={'Administration'} profile={<UserProfileContainer />} />
      <SpaceWrapper>
        <Grid templateColumns={'max-content 1fr'}>
          <LeftSideAdministrationMenu url={url} />
          <Grid>
            <Switch>
              <Route path={`${path}/users`} component={AdminUsersContainer} />
              <Route path={`${path}/roles`} component={RolesContainer} />
              <Route path={`${path}/pricing`} component={PricingAdministrationContainer} />
              <Route
                path={`${path}/underwriters/:state/:underwriter?/:zone?`}
                component={UnderwriterProfileDetailContainer}
              />
              <Route path={`${path}/tags/create`} exact component={CreateTagContainer} />
              <Route path={`${path}/tags/:tagId`} exact component={EditTagContainer} />
              <Route path={`${path}/tags`} exact component={TagsContainer} />
              <Route path={`${path}/features`} component={FeaturesContainer} />
              <Route path={`${path}/features-by-role`} component={FeatureRolesContainer} />
              <Route path={`${path}/features-by-user`} component={FeatureIdentitiesContainer} />
              <Route path={'/*'} render={() => <Redirect to={`${url}/users`} />} />
            </Switch>
          </Grid>
        </Grid>
      </SpaceWrapper>
    </>
  );
};
